/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shy_Vivid_Tortoise_SnipInputs */

const en_shy_vivid_tortoise_snip = /** @type {(inputs: Shy_Vivid_Tortoise_SnipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const de_shy_vivid_tortoise_snip = /** @type {(inputs: Shy_Vivid_Tortoise_SnipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {Shy_Vivid_Tortoise_SnipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shy_vivid_tortoise_snip = /** @type {((inputs?: Shy_Vivid_Tortoise_SnipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shy_Vivid_Tortoise_SnipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shy_vivid_tortoise_snip(inputs)
	return de_shy_vivid_tortoise_snip(inputs)
});